
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"6","height":"6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.809 4.047l-.508.867L3.293 3.5l.227 2.445H2.488L2.723 3.5.707 4.914l-.516-.867L2.426 3 .19 1.96l.516-.874L2.723 2.5 2.488.055H3.52L3.293 2.5l2.008-1.414.508.875L3.582 3l2.227 1.047z","fill":"currentColor"}})])
          )
        }
      }
    